module.exports = __webpack_public_path__ + "static/img/who-is-bg.389d732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/who-is-bg.png
// module id = UgB3
// module chunks = 0